import { Picker } from 'antd-mobile';
import { PickerValue, PickerValueExtend } from 'antd-mobile/es/components/picker-view';

interface SelectPickerProps {
  title?: string;
  confirmText?: string;
  cancelText?: string;
  visible: boolean;
  columns: { label: string; value: string }[][];
  defaultValue?: string;
  onClose: () => void;
  onConfirm: (selectedValue: PickerValue[], extendValue: PickerValueExtend) => void;
}

export const SelectPicker = ({
  title,
  confirmText = '확인',
  cancelText = '취소',
  visible,
  columns,
  defaultValue,
  onClose,
  onConfirm,
}: SelectPickerProps) => {
  return (
    <Picker
      style={{
        '--title-font-size': '16px',
        '--header-button-font-size': '16px',
        '--item-height': '48px',
      }}
      mouseWheel
      title={title}
      defaultValue={defaultValue ? [defaultValue] : undefined}
      confirmText={confirmText}
      cancelText={cancelText}
      visible={visible}
      columns={columns}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};
